import React from "react";
import {useTranslation} from "react-i18next";
import {BarReportWidget} from "../BarReportWidget/BarReportWidget";

export const DailyOrderStatsWidget = ({data = [], loading}) => {
    const {t} = useTranslation(["dailyOrderStatsWidget", "days"]);
    const days = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
    const resolver = dailyStatsArr =>
        dailyStatsArr.map((avgDailyDelivered, i) => ({
            name: t(days[i], {ns: "days"}),
            value: Math.round(avgDailyDelivered)
        }));

    return (
        <BarReportWidget
            barColor={"#72ECA5"}
            data={resolver(data)}
            height={200}
            loading={loading}
            title={<h1>{t("dailyOrderTitle", {ns: "dailyOrderStatsWidget"})}</h1>}
        />
    );
};
